import { useRef, useEffect } from "react";
import { createRoot } from "react-dom/client";

import "./black-friday.scss";
import htmlToElement from "./../../wp-utils/v1/htmlToElement";
// add promo notice
document.addEventListener("DOMContentLoaded", function () {
  if (window.h5apPlayer?.isPipe) {
    return;
  }
  const menu = document.querySelector("#wp-admin-bar-bp3d_offer_menu");
  const wrap = document.querySelector(".wrap");
  if (!wrap) return;
  const offerElement = document.createElement("div");
  const html = `<div class='bp3d-admin-notice-wrap'>
          <div class='bpl-admin-notice bpl-promotion'>
              <div class='notice-content'>
                  <div class='logo-wrap'>
                      <div class='bpl-logo'>
                          <img src='https://ps.w.org/3d-viewer/assets/icon-128x128.png' />
                      </div>
                      <span class='bpl-icon bpl-icon-promotion'></span>
                  </div>
  
                  <div class='bpl-message'>
                      <h3>Black Friday to Cyber Monday Exclusive.</h3>
                      <div>Upgrade your WordPress experience with <strong>3D Viewer Pro</strong> and save up to 40% during our biggest sale of the year!</div>
                      <a href='edit.php?post_type=bp3d-model-viewer&page=3d-viewer-pricing-manual' class='bpl-btn bpl-btn-primary'>Save Big →</a>
                  </div>
  
                  <button class='bplPromoClose close-notice'>
                      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
                          <path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
                      </svg>
                  </button>
              </div>
          </div>
      </div>`;

  offerElement.appendChild(htmlToElement(html));

  wrap.insertAdjacentElement("afterbegin", offerElement);

  const closeEl = offerElement.querySelector(".bplPromoClose");

  const isClosed = localStorage.getItem("bp3dPromoClosed");

  if (isClosed) {
    offerElement.classList.add("hidden");
  }

  closeEl?.addEventListener("click", (e) => {
    e.preventDefault();
    offerElement.classList.toggle("hidden");

    localStorage.setItem("bp3dPromoClosed", true);
  });

  menu?.addEventListener("click", function (e) {
    e.preventDefault();
    offerElement.classList.toggle("hidden");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const upgradePageEl = document.getElementById("fsUpgradePrice");
  if (!upgradePageEl || window.bp3dPlugin?.isPipe) {
    return;
  }
  const pricingNotice = document.querySelector(".bp3d-admin-notice-wrap");
  if (pricingNotice) {
    pricingNotice.classList.add("hidden");
  }

  const span = document.createElement("span");
  upgradePageEl.insertAdjacentElement("afterbegin", span);

  createRoot(span).render(<UpgradePageContent />);
});

export const UpgradePageContent = () => {
  const countdownRef = useRef(null);

  useEffect(() => {
    downCount(countdownRef?.current, {
      date: `11/27/2023 23:59:00`,
      // offset: +6
    });
  }, []);

  return (
    <>
      <section className="intro">
        <div className="container">
          <div className="introHeader flex">
            <span>Experience the thrill of Black Friday with an epic 40% off!</span> <span style={{ color: "#ff5757" }}>Ending On</span>
            {/* <img width='60px' src='https://tastewp.com/intro/emoji.svg' /> */}
          </div>

          <div className="countdownWrap">
            <div className="countdown" ref={countdownRef}>
              <div>
                <span className="days">00</span>
                <span className="days_ref">days</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="hours">00</span>
                <span className="hours_ref">hours</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="minutes">00</span>
                <span className="minutes_ref">minutes</span>
              </div>
              <span>
                :<br />
                &nbsp;
              </span>
              <div>
                <span className="seconds">00</span>
                <span className="seconds_ref">seconds</span>
              </div>
            </div>
          </div>

          <div className="promoCode">Coupon: [FSBFCM2023]</div>
        </div>
      </section>
    </>
  );
};

const downCount = (container, options, callback) => {
  const settings = Object.assign({ date: null, offset: null }, options);

  const getText = (sl) => container.querySelector(sl).textContent;
  const setText = (sl, val) => {
    container.querySelector(sl).textContent = val;
  };

  if (!settings.date) {
    throw new Error("Date is not defined.");
  }

  if (!Date.parse(settings.date)) {
    throw new Error("Incorrect date format, it should look like this, 12/24/2012 12:00:00.");
  }

  const currentDate = () => {
    // get the client's current date
    const date = new Date();

    // turn the date to UTC
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;

    return new Date(utc + 3600000 * settings.offset); // return a new Date object
  };

  function countdown() {
    // difference of dates
    const difference = new Date(settings.date) - currentDate();

    // if the difference is negative, then it's past the target date
    if (difference < 0) {
      // stop the timer
      clearInterval(interval);

      if (callback && typeof callback === "function") {
        callback();
      }

      return;
    }

    // basic math variables
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    // calculate dates
    var days = Math.floor(difference / _day);
    var hours = Math.floor((difference % _day) / _hour);
    var minutes = Math.floor((difference % _hour) / _minute);
    var seconds = Math.floor((difference % _minute) / _second);

    // fix dates so that they will show two digits
    days = String(days).length >= 2 ? days : "0" + days;
    hours = String(hours).length >= 2 ? hours : "0" + hours;
    minutes = String(minutes).length >= 2 ? minutes : "0" + minutes;
    seconds = String(seconds).length >= 2 ? seconds : "0" + seconds;

    // based on the date change the reference wording
    var refDays = days === "01" ? "day" : "days";
    var refHours = hours === "01" ? "hour" : "hours";
    var refMinutes = minutes === "01" ? "minute" : "minutes";
    var refSeconds = seconds === "01" ? "second" : "seconds";

    // set the values to the DOM
    setText(".days", days);
    setText(".hours", hours);
    setText(".minutes", minutes);
    setText(".seconds", seconds);

    getText(".days_ref") === "days" && setText(".days_ref", refDays);
    getText(".hours_ref") === "hours" && setText(".hours_ref", refHours);
    getText(".minutes_ref") === "minutes" && setText(".minutes_ref", refMinutes);
    getText(".seconds_ref") === "seconds" && setText(".seconds_ref", refSeconds);
  }

  // start
  var interval = setInterval(countdown, 1000);

  // Return the interval for later use or stopping the countdown if needed
  return interval;
};
